var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/calendar-edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-edit_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.332 4.27441V9.27441",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M26.668 4.27441V9.27441",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.83203 16.0918H34.1654",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M32.017 27.2245L26.1171 33.1246C25.8837 33.3579 25.667 33.7912 25.617 34.1079L25.3004 36.3579C25.1837 37.1746 25.7504 37.7412 26.5671 37.6246L28.8171 37.3079C29.1337 37.2579 29.5837 37.0412 29.8004 36.8079L35.7004 30.9079C36.7171 29.8913 37.2004 28.7079 35.7004 27.2079C34.2171 25.7246 33.0337 26.2079 32.017 27.2245Z",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M31.168 28.0742C31.668 29.8742 33.068 31.2742 34.868 31.7742",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M20 37.6077H13.3333C7.5 37.6077 5 34.2744 5 29.2744V15.1077C5 10.1077 7.5 6.77441 13.3333 6.77441H26.6667C32.5 6.77441 35 10.1077 35 15.1077V20.9411",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.9921 23.7747H20.0071",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.8242 23.7747H13.8391",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.8242 28.7747H13.8391",
    stroke: "#8B8C8C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarEdit);
export default __webpack_public_path__ + "static/media/calendar-edit.f460759a0f7d7d4a6c6b9141f6f3b1ec.svg";
export { ForwardRef as ReactComponent };